import React, { useState } from 'react';
import { Collapse, useTheme } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DSBox from './DSBox';
import DSTypography from './Typography/DSTypography';

// --ks-surface-4 from the Klydo Studio design system (rgb(44,44,44)).
const KS_SURFACE_4 = '#2C2C2C';
const KS_CARD_BORDER = 'rgba(255, 255, 255, 0.06)';
const KS_DIVIDER = 'rgba(255, 255, 255, 0.08)';

type DSCollapsibleSectionProps = {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
};

const DSCollapsibleSection = ({
  title,
  children,
  defaultOpen = true,
}: DSCollapsibleSectionProps) => {
  const { palette, spacing } = useTheme();
  const [open, setOpen] = useState(defaultOpen);

  return (
    <DSBox
      sx={{
        backgroundColor: KS_SURFACE_4,
        border: `1px solid ${KS_CARD_BORDER}`,
        borderRadius: spacing(2.25),
        overflow: 'hidden',
      }}
    >
      <DSBox
        onClick={() => setOpen((prev) => !prev)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: spacing(2),
          padding: spacing(2.5, 3),
          borderBottom: open ? `1px solid ${KS_DIVIDER}` : 'none',
          cursor: 'pointer',
        }}
      >
        <DSTypography
          variant="h6"
          sx={{
            flex: 1,
            fontFamily: 'Gilroy-Bold',
            color: palette.text.primary,
          }}
        >
          {title}
        </DSTypography>
        <ExpandMoreIcon
          sx={{
            color: palette.white[56],
            transition: 'transform .2s ease',
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        />
      </DSBox>
      <Collapse in={open}>{children}</Collapse>
    </DSBox>
  );
};

export default DSCollapsibleSection;
